import { ProviderType } from 'features/connections'

export const limitOfNumberOfLegendEntries = 20

export const selectAll = ({ source, provider }) => {
  switch (provider) {
    case ProviderType.BIGQUERY:
      return `SELECT * FROM \`${source}\``
    case ProviderType.REDSHIFT:
    case ProviderType.SNOWFLAKE:
    case ProviderType.POSTGRES:
      return `SELECT * FROM ${source
        .split('.')
        .map((partial) => `"${partial}"`)
        .join('.')}`
  }
}

// Request limitOfNumberOfLegendEntries + 1 elements to apply the limitOfNumberOfLegendEntries on client side
export const calculateLegendQuery = ({ source: rawSource, label: labelColumn, color: colorColumn, provider }) => {
  const source = cleanSemicolon(rawSource)

  switch (provider) {
    case ProviderType.BIGQUERY:
    case ProviderType.REDSHIFT:
    case ProviderType.POSTGRES:
      return `
        with __layerdata as (
          ${source}
        ), __data as (
          select ${labelColumn} as label, ${colorColumn} as color, count(*) __count
          from __layerdata
          group by ${labelColumn}, ${colorColumn}
        )
        select label, color
        from __data
        order by __count desc limit ${limitOfNumberOfLegendEntries + 1}; 
      `
    case ProviderType.SNOWFLAKE:
      return `
        with __layerdata as (
          ${source}
        ), __data as (
          select ${labelColumn} as "label", ${colorColumn} as "color", count(*) __count
          from __layerdata
          group by ${labelColumn}, ${colorColumn}
        )
        select "label", "color"
        from __data
        order by __count desc limit ${limitOfNumberOfLegendEntries + 1}; 
      `
    default:
      return `select 1 as error`
  }
}

const cleanSemicolon = (query) => {
  if (query.trim().charAt(query.trim().length - 1) === ';') {
    return query.trim().slice(0, -1)
  }
  return query
}
